import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackToggledEmailDigestOff.meta';

export const useTrackToggledEmailDigestOff = () => {
  const { track } = useAnalyticsUtilities();

  const trackToggleEmailDigestOff = useCallback(() => {
    track(META.name);
  }, [track]);

  return {
    trackToggleEmailDigestOff,
  };
};
